'use client';

import React from 'react';
import { ROUTE_PATHS } from '@constants/page';
import classNames from 'classnames';
import { useRouter } from 'next/navigation';
import { createTestHook } from '@royalaholddelhaize/ah-customer-care-components/utils';
import { useTranslations } from '@royalaholddelhaize/ah-next-core/src/i18n/client';
import { Locale } from '@royalaholddelhaize/ah-web-core';
import {
    ChoiceChip,
    ChoiceChipGroup,
    ChoiceChipText,
} from '@royalaholddelhaize/design-system-pantry-web/components/choice-chip/choice-chip';
import {
    FieldLabel,
    FieldLabelText,
} from '@royalaholddelhaize/design-system-pantry-web/components/field-label/field-label';
import { FormRow } from '@royalaholddelhaize/design-system-pantry-web/components/form/form';
import css from './selector-form-row.module.scss';

interface ProductComplaintSelectorProps {
    // eslint-disable-next-line react/require-default-props
    selection?: 'store' | 'online';
}

export const ProductComplaintSelector: React.FC<
    ProductComplaintSelectorProps & React.ComponentProps<'fieldset'>
> = ({ selection, className, ...restProps }) => {
    const { t } = useTranslations('product-complaint');
    const router = useRouter();

    return (
        <FormRow
            className={classNames(css.root, className)}
            {...createTestHook('complaint-form-selector')}
            {...restProps}
        >
            <FieldLabel>
                <FieldLabelText>{t('selector.title')}</FieldLabelText>
            </FieldLabel>
            <ChoiceChipGroup
                aria-label={t('a11y.selector')}
                className={css.selector}
            >
                <ChoiceChip
                    type="radio"
                    name="store"
                    className={css.option}
                    checked={selection === 'store'}
                    // fixes nextjs errors even though we don't need to handle the change event
                    onChange={() => {}}
                    onClick={() => {
                        router.push(ROUTE_PATHS.PRODUCT_COMPLAINT_FORM_STORE);
                    }}
                >
                    <ChoiceChipText className={css.optionText}>
                        {t('selector.option.store')}
                    </ChoiceChipText>
                </ChoiceChip>
                <ChoiceChip
                    type="radio"
                    name="online"
                    className={css.option}
                    checked={selection === 'online'}
                    // fixes nextjs errors even though we don't need to handle the change event
                    onChange={() => {}}
                    onClick={() => {
                        router.push(ROUTE_PATHS.PRODUCT_COMPLAINT_FORM_ONLINE);
                    }}
                >
                    <ChoiceChipText className={css.optionText}>
                        {t('selector.option.online')}
                    </ChoiceChipText>
                </ChoiceChip>
            </ChoiceChipGroup>
        </FormRow>
    );
};
